import React, { useEffect, useState } from "react";
import { DialogBox } from "../../shared/components/dialog";
import { Box, DialogContent, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, LinearProgress, OutlinedInput, Stack, TextField, Typography } from "@mui/material";
import { changePassword, getUserInfo } from "../../redux/features/user.slice";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux/features/rootSlice";
import { passwordRegex, sixDigitOTPRegex,calculatePasswordStrength } from "../../shared/util/authentication.regex";
import { MESSAGES, webSocketMessage } from "../../config/app";
import EyeCloseIcon from "../../shared/icon/eye-close-icon";
import EyeOpenIcon from "../../shared/icon/eye-open-icon";
import useWebSocket from "../../hooks/useWebSocket";
import { ButtonComponent } from "../../shared/components/button";
import useCountdownTimer from "../../hooks/useCountdownTimer";
import { getCodeForPassword, updatePasswordWithCode } from "../../redux/features/auth.slice";
import { removeCookie, setCookie } from "../token";
import { useArcAuth } from "@arcauth/react-sdk";
import { red } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
export interface DialogProps {
  open: boolean;
  onClose: () => void;
}
interface password {
  newpassword: string;
  confirmpassword: string;
}
const SetPassword = (props: DialogProps) => {
  const dispatch = useDispatch();
  const { logout } = useArcAuth();
  const navigate = useNavigate();
  const { open, onClose } = props;
  const { updateUserAndNotifyParent } = useWebSocket();
  const { timeLeft, resendButtonEnabled, resetTimer } = useCountdownTimer(180); // 3 minutes
  const [password, setPassword] = useState<password>({ newpassword: "", confirmpassword: "" });
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [isNewPasswordTouched, setIsNewPasswordTouched] = useState(false);
  const [newPasswordHelperText, setNewPasswordHelperText] = useState("");
  const [isConfirmPasswordTouched, setIsConfirmPasswordTouched] = useState(false);
  const [confirmPasswordHelperText, setConfirmPasswordHelperText] = useState("");
  const [passwordCode, setPasswordCode] = useState(false);
  const [securityCode, setSecurityCode] = useState("");
  const [sentTo, setSentTo] = useState("");
  const [strength, setStrength] = useState(0);
  const [strengthLabel, setStrengthLabel] = useState('');

  const getCode_loading = useSelector(
    (state: RootStateType) => state.authStateReducer.getCodeLoading
  );
  const setPassword_Loading = useSelector(
    (state: RootStateType) => state.authStateReducer.setPasswordLoading
  );
  const storedClientId = useSelector((state: RootStateType) => state.configStateReducer.clientId);
  const clientType = useSelector((state: RootStateType) => state.deviceConfigReducer.clientType);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  // update password with security code
  const handleListItemClick = async (password: any) => {
    // if (password.newpassword != password.confirmpassword) {
    //   console.log("new password and confirm password does not match");
    // }
    setPasswordCode(true);
    const dispatchObj = {
      body: {
        password: password.newpassword,
        code: securityCode
      },
      successMessage: MESSAGES.setPasswordSuccess,
      callBackSuccess: () => {
        updateUserAndNotifyParent(webSocketMessage.passwordResponse);
        dialogClose();
        setPasswordCode(false);
        setSecurityCode("");
        dispatch(getUserInfo());
        setButtonEnabled(false);
        /**
            * NOTE: on uncommenting this user will be logout from current browser
            * after setting password with security code.
        */ 
        // removeCookie(`lastState=`, 0, storedClientId);
        // removeCookie(`user=`, 0, storedClientId);
        // setCookie(`app.at_exp=`, 0, storedClientId);
        // setCookie(`app.at=`, 0, storedClientId);
        // setCookie(`app.rt=`, 0, storedClientId);
        // localStorage.clear();
        // if (clientType && clientType == 'device') {
        //   // navigate("/error");
        //   // Trigger the custom protocol
        //   window.location.href = 'arcauth.facilities:/oauthredirect';
        // }
        // else {
        //   logout();
        // }  
      },
      callBackFailure: () => {
        setButtonEnabled(false);
      },
    };
    dispatch(updatePasswordWithCode(dispatchObj));
  };

  // Send security code for password setting
  const validatePasswordAndSendCode = () => {
    const sendCodeObj = {
      callBackSuccess: (sentTo: any) => {
        setSentTo(sentTo);
        setPasswordCode(true);
        resetTimer();
        setSecurityCode("");
        setButtonEnabled(false);
      },
      callBackFailure: () => {
        setButtonEnabled(false);
        setPassword({
          newpassword: "",
          confirmpassword: ""
        });
        setShowPassword(false);
      },
    };
    dispatch(getCodeForPassword(sendCodeObj));
  };

  const checkNewPassword = (newpassword: string, password: any) => {
    setIsNewPasswordTouched(true);
  
    if (newpassword.length < 1) {
      setStrength(0);
      setStrengthLabel('');
      setNewPasswordHelperText("");
      return;
    }
  
    const strengthCount = calculatePasswordStrength(newpassword);
  
    let calculatedStrength = 0;
    let calculatedLabel = '';
  
    if (strengthCount === 4) {
      calculatedStrength = newpassword.length > 8 ? 100 : 80;
      calculatedLabel = newpassword.length > 8 ? 'Strong' : 'Good';
    } else if (strengthCount === 3) {
      calculatedStrength = 60;
      calculatedLabel = 'Weak';
    } else if (strengthCount === 2) {
      calculatedStrength = 40;
      calculatedLabel = 'Poor';
    } else {
      calculatedStrength = 20;
      calculatedLabel = 'Poor';
    }
  
    setStrength(calculatedStrength);
    setStrengthLabel(calculatedLabel);
    setNewPasswordHelperText("");
    
    if (newpassword === password.confirmpassword) {
      setConfirmPasswordHelperText(""); // Reset confirm password helper text
    }
  };

  const checkConfirmPassword = (confirmpassword: any, password: any) => {
    setIsConfirmPasswordTouched(true);
    if (isConfirmPasswordTouched && confirmpassword.length < 1) {
      setConfirmPasswordHelperText("");
    } else if (password.newpassword !== confirmpassword) {
      setConfirmPasswordHelperText("New password and confirm password does not match");
    } else {
      setConfirmPasswordHelperText("");
    }
  };

  const clearForm = () => {
    setIsNewPasswordTouched(false);
    setNewPasswordHelperText("");
    setIsConfirmPasswordTouched(false);
    setConfirmPasswordHelperText("");

    setPassword({
      newpassword: "",
      confirmpassword: ""
    });
    setSentTo("");
  };
  const dialogClose = () => {
    setPasswordCode(false);
    resetTimer();
    onClose();
    clearForm();
    setShowPassword(false);
    setStrength(0);
    setStrengthLabel('');
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      validatePasswordAndSendCode();
    }
  };
  const handleKeyDownCode = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      handleListItemClick(password);
    }
  };
  
// Function to get the appropriate MUI color based on strength
const getProgressColor = (strength: number): 'primary' | 'secondary' | 'error' | 'warning' | 'success' => {
  return strength >= 80 ? 'success' : 
         strength >= 60 ? 'warning' : 
         strength >= 40 ? 'secondary' :  // We'll apply custom light red styling via sx
         strength >= 20 ? 'error' : 'secondary';
};
  
  useEffect(() => {
    // Check if any of the passwords is empty or if confirm password is weak
    if (
      password.newpassword === "" ||
      password.confirmpassword === "" ||
      !passwordRegex.test(password.confirmpassword) ||
      password.newpassword !== password.confirmpassword // Check if new password doesn't match confirm password
    ) {
      // If any of the conditions above is true, disable the button
      setButtonEnabled(false);
    } else {
      // If all passwords are filled and confirm password is not weak, enable the button
      setButtonEnabled(true);
    }
  }, [password]);

  useEffect(() => {
    if (securityCode === "") {
      setButtonEnabled(false);
      //setEmailHelperText("Email cannot be empty");
    } else if (securityCode.length === 6 && sixDigitOTPRegex.test(securityCode)) {
      setButtonEnabled(true);
    } else {
      setButtonEnabled(false);
      //setEmailHelperText("Invalid code");
    }
  }, [securityCode]);

  return (
    <>
      <DialogBox
        onClose={dialogClose}
        className="password-set"
        title={"Set password"}
        // buttonText={"Update"}
        // buttonClick={() => { handleListItemClick(password) }}
        buttonText={passwordCode ? 'Update' : 'Continue'}
        buttonClick={() => passwordCode ? handleListItemClick(password) : Promise.resolve(validatePasswordAndSendCode()).then(() => { }).catch(() => { })}
        isLoading={passwordCode ? setPassword_Loading : getCode_loading}
        isBtnEnabled={!buttonEnabled}
        open={open}
        style={{ maxWidth: 500, mx: "auto" }}
         buttonAriaLabel={"Click to update your password"}
      >
        {!passwordCode ?
          <>
            <DialogContent>
              <Stack gap={2}>
                <Box>
                  <FormControl fullWidth size="small" variant="outlined"
                    color="secondary">

                    {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
                    <label htmlFor="password" style={{fontSize: 13}}>Password</label>
                    <OutlinedInput
                      id="password"
                      type={showPassword ? 'text' : 'password'}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <EyeOpenIcon /> : <EyeCloseIcon />}
                          </IconButton>
                        </InputAdornment>
                      }
                      //label="Password"
                      size="small" fullWidth placeholder="Enter new password" color="secondary" autoFocus inputProps={{ maxLength: 100 }} value={password.newpassword} onKeyDown={handleKeyDown}
                      onChange={(e) => {
                        checkNewPassword(e.target.value, password);
                        setPassword({ confirmpassword: password.confirmpassword, newpassword: e.target.value });
                      }}
                    />
                    <FormHelperText
                      style={{
                        color: "red",
                      }}
                    >
                      {newPasswordHelperText}
                    </FormHelperText>
                  </FormControl>
                </Box>
                <div>
                <label htmlFor="confirm password" style={{fontSize: 13}}>Cofirm password</label>
                  <TextField id ="confirm password" size="small" fullWidth placeholder="Enter confirm password" type="password" color="secondary" inputProps={{ maxLength: 100 }} value={password.confirmpassword} onKeyDown={handleKeyDown}
                    onChange={(e) => {
                      checkConfirmPassword(e.target.value, password);
                      setPassword({ newpassword: password.newpassword, confirmpassword: e.target.value });
                    }} 
                    onPaste={(e) => {
                      e.preventDefault(); // Prevent pasting
                  }}
                  />
                  <FormHelperText
                    style={{
                      color: "red",
                    }}
                  >
                    {confirmPasswordHelperText}
                  </FormHelperText>
                </div>
              </Stack>
              <Box className="status-container">
                <Box className="status"> <h5><strong>Password Strength: </strong><span id="strength">{strengthLabel}</span></h5>
                  <Box className="progress-bar">
                    <LinearProgress
                      variant="determinate"
                      value={strength}
                color={getProgressColor(strength)}
                sx={{
                  ...(strength >= 40 && strength < 60 && {
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: red[300], // Use a light red color (adjust shade as needed)
                    },
                  }),
                }}
                    />
                  </Box>
                  <ul>
                    <li>Use at least 8 characters.</li>
                    <li>Include both lowercase and uppercase letters.</li>
                    <li>Include at least one digit.</li>
                    <li>Include at least one symbol (!@#$%^&amp;*_-+=).</li>
                    <li>Avoid using your name or email in the password.</li>
                  </ul>
                </Box>
              </Box>
            </DialogContent>
          </>
          :
          <DialogContent>
            <Typography variant="body1" color="initial" textAlign={'center'} gutterBottom>
              Please share the 6-digit security code sent to {sentTo} </Typography>
              <label htmlFor="security code" style={{fontSize: 13}}>Security code</label>
            <TextField
              id="security code"
              size="small"
              fullWidth
              autoFocus
              // label="Security code"
              value={securityCode ?? ""}
              placeholder="Enter security code"
              color="secondary"
              inputProps={{ maxLength: 6 }}
              onKeyDown={handleKeyDownCode}
              onChange={(e) => {
                setSecurityCode(e.target.value);
              }}
            />
            <Stack direction={'row'} justifyContent={"space-between"} alignItems="center">
              <Box>{timeLeft}</Box>
              <ButtonComponent buttonName="Resend" variant="text" color="secondary" onClickHandle={() => {
                resetTimer();
                validatePasswordAndSendCode();
              }} isBtnEnabled={!resendButtonEnabled} isLoading={getCode_loading}/>
            </Stack>
          </DialogContent>
        }

      </DialogBox>
    </>
  );
};

export default SetPassword;
